/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */

/**
 * Attached invoice file status (添付請求書)
 */
export type SearchInvoiceReportsQueryMfFile =
  (typeof SearchInvoiceReportsQueryMfFile)[keyof typeof SearchInvoiceReportsQueryMfFile];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SearchInvoiceReportsQueryMfFile = {
  not_attached: 'not_attached',
  attached: 'attached',
  attached_receipt_type_paper: 'attached_receipt_type_paper',
  attached_receipt_type_e_doc: 'attached_receipt_type_e_doc',
} as const;
